
import * as React from 'react';
import ModulesAction from './Modules.Action';
import { document } from 'src/api';

class ModulesFormAction {
    /**
     * 拼装并验证数据(订单) 
     */
    public checkDateOrder = (validate?: boolean) => {
        let orderForm = {
            DocumentType: ModulesAction.modulesState.documentType,
            ID: '',
            IssueDate: '',
            DocumentCurrencyCode: '',
            BuyerCustomerParty: ModulesAction.modulesState.orderForm.BuyerCustomerParty,
            BuyerContact: ModulesAction.modulesState.orderForm.BuyerContact,
            SellerSupplierParty: ModulesAction.modulesState.orderForm.SellerSupplierParty,
            SellerContact: {
                ID: '',
                Name: '',
            },
            RequestedDeliveryPeriod: {
                StartDate: '',
                EndDate: '',
            },
            Lines: [],
            Total: ModulesAction.modulesState.orderForm.Total,
            PaymentMeans: '',
            Note: '',
            DeliveryAddress: {
                Country: undefined,
                CountrySubentity: undefined,
                CityName: undefined,
                AddressLine: '',
            },
            DeliveryContact: {
                Name: '',
                Phone: '',
            },
            Attachments: [{
                FileName: '',
                UUID: '',
            }],
        };
        let checkValidate = true;
        ModulesAction.modulesState.formList.forEach((item, index) => {
            item && item.validateFieldsAndScroll({ force: true }, (err, values) => {
                if (err) {
                    checkValidate = false;
                }
                if (validate || checkValidate) {
                    // 基础单据数据拼装
                    if (index === 0) {
                        orderForm.ID = values.ID;
                        orderForm.IssueDate = values.IssueDate && values.IssueDate.valueOf();
                        orderForm.SellerContact.Name = values.SellerContact;
                        orderForm.DocumentCurrencyCode = values.DocumentCurrencyCode;
                        orderForm.RequestedDeliveryPeriod.StartDate = values.RequestedDeliveryPeriodStartDate && values.RequestedDeliveryPeriodStartDate.valueOf();
                        orderForm.RequestedDeliveryPeriod.EndDate = values.RequestedDeliveryPeriodEndDate && values.RequestedDeliveryPeriodEndDate.valueOf();
                    }
                    // 拼装 中间 table表单
                    if (index !== 0 && (ModulesAction.modulesState.formList.length - 1) !== index) {
                        values = ModulesAction.DateformatToTimeStamp(values, true);
                        values = {
                            ...ModulesAction.modulesState.orderForm.Lines[index-1],
                            ...values,
                        };
                        orderForm.Lines.push(values);
                    }
                    // 拼装 附加信息
                    if ((ModulesAction.modulesState.formList.length - 1) === index) {
                        orderForm.PaymentMeans = values.PaymentMeans;
                        orderForm.DeliveryAddress.Country = values.Country;
                        orderForm.DeliveryAddress.CountrySubentity = values.CountrySubentity;
                        orderForm.DeliveryAddress.CityName = values.CityName;
                        orderForm.DeliveryAddress.AddressLine = values.AddressLine;
                        orderForm.DeliveryContact.Name = values.DeliveryContactName;
                        orderForm.DeliveryContact.Phone = values.DeliveryContactPhone;
                        orderForm.Note = values.Note;

                        values = ModulesAction.DateformatToTimeStamp(values, false);
                        Object.assign(orderForm, ModulesAction.addExtraForm(values, false));
                    }
                }
            });
        });

        // 拼装上传附件
        orderForm.Attachments = [];
        ModulesAction.modulesState.uploadList.forEach((item) => {
            if (item.UUID) {
                // 已上传的
                orderForm.Attachments.push({
                    UUID: item.UUID,
                    FileName: item.FileName
                });
            }
            if (item.status === "done" && item.response && item.response.ok) {
                // 新上传的
                orderForm.Attachments.push({
                    ...item.response.body[0]
                });
            }
        });
        return validate || checkValidate ? orderForm : checkValidate;
    }
    /**
     * 拼装并验证数据(发货单) 
     */
    public checkDateDespatchAdvice = (validate?: boolean) => {
        let despatchAdviceForm = {
            DocumentType: ModulesAction.modulesState.documentType,
            ID: undefined,
            IssueDate: undefined,
            DespatchSupplierParty: ModulesAction.modulesState.despatchAdviceForm.DespatchSupplierParty,
            DespatchSupplierContact: ModulesAction.modulesState.despatchAdviceForm.DespatchSupplierContact,
            DeliveryCustomerParty: ModulesAction.modulesState.despatchAdviceForm.DeliveryCustomerParty,
            DeliveryCustomerContact: {
                ID: undefined,
                Name: undefined,
            },
            Lines: [],
            DeliveryAddress: {
                Country: undefined,
                CountrySubentity: undefined,
                CityName: undefined,
                AddressLine: undefined,
            },
            DeliveryContact: {
                Name: undefined,
                Phone: undefined,
            },
            DeliveryDate: undefined,
            TransportModeCode: undefined,
            TransportMeansTrackingID: undefined,
            PerformingCarrierPartyContact: {
                ID: undefined,
                Name: undefined,
                Phone: undefined,
            },
            CarrierParty: {
                ID: undefined,
                Name: undefined,
            },
            Note: undefined,
            Attachments: [],
        };
        let checkValidate = true;
        ModulesAction.modulesState.formList.forEach((item, index) => {
            item && item.validateFieldsAndScroll({ force: true }, (err, values) => {
                if (err) {
                    checkValidate = false;
                }
                if (validate || checkValidate) {
                    // 基础单据数据拼装
                    if (index === 0) {
                        despatchAdviceForm.ID = values.ID && values.ID.replace(/(^\s*)|(\s*$)/g, "");
                        despatchAdviceForm.DeliveryCustomerContact.Name = values.DeliveryCustomerContact;
                        despatchAdviceForm.IssueDate = values.IssueDate && values.IssueDate.valueOf();
                        despatchAdviceForm.DeliveryAddress.Country = values.Country;
                        despatchAdviceForm.DeliveryAddress.CountrySubentity = values.CountrySubentity;
                        despatchAdviceForm.DeliveryAddress.CityName = values.CityName;
                        despatchAdviceForm.DeliveryAddress.AddressLine = values.AddressLine;
                        despatchAdviceForm.DeliveryContact.Name = values.DeliveryContactName;
                        despatchAdviceForm.DeliveryContact.Phone = values.DeliveryContactPhone;
                    }
                    // 拼装 中间 table表单
                    if (index !== 0 && (ModulesAction.modulesState.formList.length - 1) !== index) {
                        // 去空格
                        values.DocumentReference = values.DocumentReference && values.DocumentReference.replace(/(^\s*)|(\s*$)/g, "");
                        values.LineReference = values.LineReference && values.LineReference.replace(/(^\s*)|(\s*$)/g, "");
                        values.ID = values.ID && values.ID.replace(/(^\s*)|(\s*$)/g, "");
                        values.ReceiveAddress = values.ReceiveAddress && values.ReceiveAddress.replace(/(^\s*)|(\s*$)/g, "");
                        values.ReceiveFactory = values.ReceiveFactory && values.ReceiveFactory.replace(/(^\s*)|(\s*$)/g, "");

                        values = ModulesAction.DateformatToTimeStamp(values, true);
                        values = {
                            ...ModulesAction.modulesState.despatchAdviceForm.Lines[index-1],
                            ...values,
                        };
                        despatchAdviceForm.Lines.push(values);
                    }
                    // 拼装 附加信息
                    if ((ModulesAction.modulesState.formList.length - 1) === index) {
                        despatchAdviceForm.DeliveryDate = values.DeliveryDate && values.DeliveryDate.valueOf();
                        despatchAdviceForm.TransportModeCode = values.TransportModeCode;
                        despatchAdviceForm.TransportMeansTrackingID = values.TransportMeansTrackingID;
                        despatchAdviceForm.PerformingCarrierPartyContact.Name = values.PerformingCarrierPartyContactName;
                        despatchAdviceForm.PerformingCarrierPartyContact.Phone = values.PerformingCarrierPartyContactPhone;
                        despatchAdviceForm.CarrierParty.Name = values.CarrierParty;
                        despatchAdviceForm.Note = values.Note;

                        values = ModulesAction.DateformatToTimeStamp(values, false);
                        Object.assign(despatchAdviceForm, ModulesAction.addExtraForm(values, false));
                    }
                }
            });
        });

        // 拼装上传附件
        despatchAdviceForm.Attachments = [];
        ModulesAction.modulesState.uploadList.forEach((item) => {
            if (item.UUID) {
                // 已上传的
                despatchAdviceForm.Attachments.push({
                    UUID: item.UUID,
                    FileName: item.FileName
                });
            }
            if (item.status === "done" && item.response && item.response.ok) {
                // 新上传的
                despatchAdviceForm.Attachments.push({
                    ...item.response.body[0]
                });
            }
        });
        return validate || checkValidate ? despatchAdviceForm : checkValidate;
    }
    /**
     * 拼装并验证数据(合同) 
     */
    public checkDateContract = (validate?: boolean) => {
        let ContractForm = {
            DocumentType: ModulesAction.modulesState.documentType,
            ID: '',
            IssueDate: '',
            DocumentCurrencyCode: '',
            BuyerCustomerParty: ModulesAction.modulesState.ContractForm.BuyerCustomerParty,
            BuyerContact: ModulesAction.modulesState.ContractForm.BuyerContact,
            SellerSupplierParty: ModulesAction.modulesState.ContractForm.SellerSupplierParty,
            SellerContact: {
                ID: '',
                Name: '',
            },
            ValidityPeriod: {
                StartDate: undefined,
                EndDate: undefined,
            },
            Lines: [],
            Total: 0,
            Note: '',
            Attachments: [],
        };
        let checkValidate = true;
        ModulesAction.modulesState.formList.forEach((item, index) => {
            item && item.validateFieldsAndScroll({ force: true }, (err, values) => {
                if (err) {
                    checkValidate = false;
                }
                if (validate || checkValidate) {
                    // 基础单据数据拼装
                    if (index === 0) {
                        ContractForm.ID = values.ID;
                        ContractForm.IssueDate = values.IssueDate && values.IssueDate.valueOf();
                        ContractForm.SellerContact.Name = values.SellerContact;
                        ContractForm.DocumentCurrencyCode = values.DocumentCurrencyCode;
                        ContractForm.ValidityPeriod.StartDate = values.ValidityPeriodStartDate && values.ValidityPeriodStartDate.valueOf();
                        ContractForm.ValidityPeriod.EndDate = values.ValidityPeriodEndDate && values.ValidityPeriodEndDate.valueOf();
                    }
                    // 拼装 中间 table表单
                    if (index !== 0 && (ModulesAction.modulesState.formList.length - 1) !== index) {
                        values = ModulesAction.DateformatToTimeStamp(values, true);
                        values = {
                            ...ModulesAction.modulesState.ContractForm.Lines[index-1],
                            ...values,
                        };
                        ContractForm.Lines.push(values);
                    }
                    // 拼装 附加信息
                    if ((ModulesAction.modulesState.formList.length - 1) === index) {
                        ContractForm.Note = values.Note;

                        values = ModulesAction.DateformatToTimeStamp(values, false);
                        Object.assign(ContractForm, ModulesAction.addExtraForm(values, false));
                    }
                }
            });
        });

        // 拼装上传附件
        ContractForm.Attachments = [];
        ModulesAction.modulesState.uploadList.forEach((item) => {
            if (item.UUID) {
                // 已上传的
                ContractForm.Attachments.push({
                    UUID: item.UUID,
                    FileName: item.FileName
                });
            }
            if (item.status === "done" && item.response && item.response.ok) {
                // 新上传的
                ContractForm.Attachments.push({
                    ...item.response.body[0]
                });
            }
        });
        return validate || checkValidate ? ContractForm : checkValidate;
    }
    /**
     * 拼装并验证数据(计划单) 
     */
    public checkDateForecast = (validate?: boolean) => {
        let forecastForm = {
            DocumentType: ModulesAction.modulesState.documentType,
            ID: undefined,
            IssueDate: undefined,
            DocumentCurrencyCode: undefined,
            SenderParty: ModulesAction.modulesState.forecastForm.SenderParty,
            SenderContact: ModulesAction.modulesState.forecastForm.SenderContact,
            ReceiverParty: ModulesAction.modulesState.forecastForm.ReceiverParty,
            ReceiverContact: {
                ID: undefined,
                Name: undefined,
            },
            ForecastPeriod: {
                StartDate: undefined,
                EndDate: undefined,
            },
            Lines: [],
            Note: undefined,
            Attachments: [],
        };
        let checkValidate = true;
        ModulesAction.modulesState.formList.forEach((item, index) => {
            item && item.validateFieldsAndScroll({ force: true }, (err, values) => {
                if (err) {
                    checkValidate = false;
                }
                if (validate || checkValidate) {
                    // 基础单据数据拼装
                    if (index === 0) {
                        forecastForm.ID = values.ID;
                        forecastForm.IssueDate = values.IssueDate && values.IssueDate.valueOf();
                        forecastForm.ReceiverContact.Name = values.ReceiverContact;
                        forecastForm.ForecastPeriod.StartDate = values.ForecastPeriodStartDate && values.ForecastPeriodStartDate.valueOf();
                        forecastForm.ForecastPeriod.EndDate = values.ForecastPeriodEndDate && values.ForecastPeriodEndDate.valueOf();
                    }
                    // 拼装 中间 table表单
                    if (index !== 0 && (ModulesAction.modulesState.formList.length - 1) !== index) {
                        values = ModulesAction.DateformatToTimeStamp(values, true);
                        values = {
                            ...ModulesAction.modulesState.forecastForm.Lines[index-1],
                            ...values,
                        };
                        forecastForm.Lines.push(values);
                    }
                    // 拼装 附加信息
                    if ((ModulesAction.modulesState.formList.length - 1) === index) {
                        forecastForm.Note = values.Note;
                        values = ModulesAction.DateformatToTimeStamp(values, false);
                        Object.assign(forecastForm, ModulesAction.addExtraForm(values, false));
                    }
                }
            });
        });

        // 拼装上传附件
        forecastForm.Attachments = [];
        ModulesAction.modulesState.uploadList.forEach((item) => {
            if (item.UUID) {
                // 已上传的
                forecastForm.Attachments.push({
                    UUID: item.UUID,
                    FileName: item.FileName
                });
            }
            if (item.status === "done" && item.response && item.response.ok) {
                // 新上传的
                forecastForm.Attachments.push({
                    ...item.response.body[0]
                });
            }
        });
        return validate || checkValidate ? forecastForm : checkValidate;
    }
    /**
     * 拼装并验证数据(收货单)
     */
    public checkDateReceiptAdvice = (validate?: boolean) => {
        let receiptAdviceForm = {
            DocumentType: ModulesAction.modulesState.documentType,
            ID: undefined,
            PostingDate: undefined,
            IssueDate: undefined,
            DespatchSupplierParty: ModulesAction.modulesState.receiptAdviceForm.DespatchSupplierParty,
            DespatchSupplierContact: {
                ID: undefined,
                Name: undefined,
            },
            DeliveryCustomerParty: ModulesAction.modulesState.receiptAdviceForm.DeliveryCustomerParty,
            DeliveryCustomerContact: ModulesAction.modulesState.receiptAdviceForm.DeliveryCustomerContact,
            DeliveryDate: undefined,
            TransportModeCode: undefined,
            TransportMeansTrackingID: undefined,
            PerformingCarrierPartyContact: {
                ID: undefined,
                Name: undefined,
            },
            CarrierParty: {
                ID: undefined,
                Name: undefined,
            },
            DeliveryNote: undefined,
            Lines: [],
            ActualDespatchDate: undefined,
            DespatchAddressLine: undefined,
            Note: undefined,
            Attachments: [],
        };
        let checkValidate = true;
        ModulesAction.modulesState.formList.forEach((item, index) => {
            item && item.validateFieldsAndScroll({ force: true }, (err, values) => {
                if (err) {
                    checkValidate = false;
                }
                if (validate || checkValidate) {
                    // 基础单据数据拼装
                    if (index === 0) {
                        receiptAdviceForm.IssueDate = values.IssueDate && values.IssueDate.valueOf();
                        receiptAdviceForm.PostingDate = values.PostingDate && values.PostingDate.valueOf();
                        receiptAdviceForm.DespatchSupplierContact.Name = values.DespatchSupplierContact;
                        receiptAdviceForm.ID = values.ID;
                    }
                    // 拼装 中间 table表单
                    if (index !== 0 && (ModulesAction.modulesState.formList.length - 1) !== index) {
                        values = ModulesAction.DateformatToTimeStamp(values, true);
                        values = {
                            ...ModulesAction.modulesState.receiptAdviceForm.Lines[index-1],
                            ...values,
                        };
                        receiptAdviceForm.Lines.push(values);
                    }
                    // 拼装 附加信息
                    if ((ModulesAction.modulesState.formList.length - 1) === index) {
                        receiptAdviceForm.ActualDespatchDate = values.ActualDespatchDate && values.ActualDespatchDate.valueOf();
                        receiptAdviceForm.Note = values.Note;
                        receiptAdviceForm.DespatchAddressLine = values.DespatchAddressLine;

                        values = ModulesAction.DateformatToTimeStamp(values, false);
                        Object.assign(receiptAdviceForm, ModulesAction.addExtraForm(values, false));
                    }
                }
            });
        });

        // 拼装上传附件
        receiptAdviceForm.Attachments = [];
        ModulesAction.modulesState.uploadList.forEach((item) => {
            if (item.UUID) {
                // 已上传的
                receiptAdviceForm.Attachments.push({
                    UUID: item.UUID,
                    FileName: item.FileName
                });
            }
            if (item.status === "done" && item.response && item.response.ok) {
                // 新上传的
                receiptAdviceForm.Attachments.push({
                    ...item.response.body[0]
                });
            }
        });
        return validate || checkValidate ? receiptAdviceForm : checkValidate;
    }
    /**
     * 拼装并验证数据(入库单)
     */
    public checkDateStockInNotice = (validate?: boolean) => {
        let stockInNoticeForm = {
            DocumentType: ModulesAction.modulesState.documentType,
            ID: undefined,
            PostingDate: undefined,
            IssueDate: undefined,
            BuyerCustomerParty: ModulesAction.modulesState.stockInNoticeForm.BuyerCustomerParty,
            BuyerContact: ModulesAction.modulesState.stockInNoticeForm.BuyerContact,
            SellerSupplierParty: ModulesAction.modulesState.stockInNoticeForm.SellerSupplierParty,
            SellerContact: {
                ID: undefined,
                Name: undefined,
            },
            PickupPeriod: {
                StartDate: undefined,
                EndDate: undefined,
            },
            Lines: [],
            Note: undefined,
            Attachments: [],
        };
        let checkValidate = true;
        ModulesAction.modulesState.formList.forEach((item, index) => {
            item && item.validateFieldsAndScroll({ force: true }, (err, values) => {
                if (err) {
                    checkValidate = false;
                }
                if (validate || checkValidate) {
                    // 基础单据数据拼装
                    if (index === 0) {
                        stockInNoticeForm.IssueDate = values.IssueDate && values.IssueDate.valueOf();
                        stockInNoticeForm.PostingDate = values.PostingDate && values.PostingDate.valueOf();
                        stockInNoticeForm.ID = values.ID;
                        stockInNoticeForm.PickupPeriod.StartDate = values.PickupPeriodStartDate && values.PickupPeriodStartDate.valueOf();
                        stockInNoticeForm.PickupPeriod.EndDate = values.PickupPeriodEndDate && values.PickupPeriodEndDate.valueOf();
                        stockInNoticeForm.SellerContact.Name = values.SellerContact;
                    }
                    // 拼装 中间 table表单
                    if (index !== 0 && (ModulesAction.modulesState.formList.length - 1) !== index) {
                        values = ModulesAction.DateformatToTimeStamp(values, true);
                        values = {
                            ...ModulesAction.modulesState.stockInNoticeForm.Lines[index-1],
                            ...values,
                        };
                        stockInNoticeForm.Lines.push(values);
                    }
                    // 拼装 附加信息
                    if ((ModulesAction.modulesState.formList.length - 1) === index) {
                        stockInNoticeForm.Note = values.Note;
                        values = ModulesAction.DateformatToTimeStamp(values, false);
                        Object.assign(stockInNoticeForm, ModulesAction.addExtraForm(values, false));
                    }
                }
            });
        });

        // 拼装上传附件
        stockInNoticeForm.Attachments = [];
        ModulesAction.modulesState.uploadList.forEach((item) => {
            if (item.UUID) {
                // 已上传的
                stockInNoticeForm.Attachments.push({
                    UUID: item.UUID,
                    FileName: item.FileName
                });
            }
            if (item.status === "done" && item.response && item.response.ok) {
                // 新上传的
                stockInNoticeForm.Attachments.push({
                    ...item.response.body[0]
                });
            }
        });
        return validate || checkValidate ? stockInNoticeForm : checkValidate;
    }
    /** 错误信息提示 */
    public setMessageInfos = (message) => {
        if (message) {
            const messages = message.split(',');
            const messageArray = [];
            messages.forEach((element, index) => {
                messageArray.push(
                    <div key={index} className="errorInfo">{element}</div>
                );
            });
            return messageArray;
        }
    }

    // Order = "订单",
    // DespatchAdvice = "发货单",
    // ReceiptAdvice = "收货单",
    // StockInNotice = "入库通知单",
    // ForecastDemand = "要货计划",
    // ForecastPrediction = "预测计划",
    // ReceiptAdviceRATC01 = "冲销入库单",
    // ReceiptAdviceReturn = "退货通知单",
    // Contract = "合同",
    // Reconciliation = "对账单",
    // ProductActivity = "商品变动单",
    // Invoice = "发票",

    /** 验证输入框信息 */
    public validateFormValue = async (param) => {
        setTimeout(() => {
            this.validateForm(param);
        }, 200);
    }
    public validateForm = async (param) => {
        if (!param.value) {
            return false;
        }
        if (!ModulesAction.modulesState.validateKeys[param.fieldName]) { // 验证字段中不包含该字段
            return false;
        }
        let content = '';
        switch (ModulesAction.modulesState.documentType) {
            case 'Order':
                content = JSON.stringify(this.checkDateOrder(true));
                break;
            case 'Contract':
                content = JSON.stringify(this.checkDateContract(true));
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                content = JSON.stringify(this.checkDateForecast(true));
                break;
            case 'DespatchAdvice':
                content = JSON.stringify(this.checkDateDespatchAdvice(true));
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                content = JSON.stringify(this.checkDateReceiptAdvice(true));
                break;
            case 'StockInNotice':
                content = JSON.stringify(this.checkDateStockInNotice(true));
                break;
            default:
                break;
        }
        param = {
            ...param,
            content: content,
            documentType: ModulesAction.modulesState.documentType,
            receiverUUID: ModulesAction.modulesState.connectionCompanyId,
        };
        const res = await document.checkField(this, param);
        if (!res.er) {
            const fieldErrors: any = res.res;
            // if(fieldErrors && fieldErrors.length > 0){
            this.saveErrorInfos(fieldErrors, param.fieldName, param.line);
            // }
        }
    }
    /** 验证整个文档 */
    /** 验证输入框信息 */
    public validateDocumentValue = async () => {
        ModulesAction.modulesState.messageInfos = new Map<string, string>();
        let content = '';
        switch (ModulesAction.modulesState.documentType) {
            case 'Order':
                content = JSON.stringify(this.checkDateOrder(true));
                break;
            case 'Contract':
                content = JSON.stringify(this.checkDateContract(true));
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                content = JSON.stringify(this.checkDateForecast(true));
                break;
            case 'DespatchAdvice':
                content = JSON.stringify(this.checkDateDespatchAdvice(true));
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                content = JSON.stringify(this.checkDateReceiptAdvice(true));
                break;
            case 'StockInNotice':
                content = JSON.stringify(this.checkDateStockInNotice(true));
                break;
            default:
                break;
        }
        const res = await document.checkDocument(this, { content: content });
        if (!res.er && res.res) {
            const fieldErrors: any = res.res;
            if (fieldErrors && fieldErrors.length > 0) {
                this.saveErrorInfos(fieldErrors);
            }
        }
    }
    /** 保存错误字段 */
    public saveErrorInfos = (fieldErrors: any[], fileName?: string, line?: number) => {
        if (fieldErrors) {
            fieldErrors.forEach(fieldError => {
                //  单个验证前后交互传输的line是每行的key，整体文档验证时传输的line是行数
                const key = fieldError.line === null ?
                    fieldError.field :
                    fieldError.field + '_' + (fileName ? fieldError.line : ModulesAction.modulesState.linesKey[fieldError.line]);
                if (fieldError.errors && fieldError.errors.length > 0) {
                    let errorMessage = '';
                    fieldError.errors.forEach(error => {
                        errorMessage += error.message + ',';
                    });
                    ModulesAction.modulesState.messageInfos.set(key, errorMessage);
                } else {
                    if (ModulesAction.modulesState.messageInfos.get(key)) {
                        ModulesAction.modulesState.messageInfos.delete(key);
                    }
                }
            });
        } else if (fileName) {  // 若没有错误，则去掉保存的错误信息
            const key = line === null ? fileName : fileName + '_' + line;
            if (ModulesAction.modulesState.messageInfos.get(key)) {
                ModulesAction.modulesState.messageInfos.delete(key);
            }
        }
        ModulesAction.setModulesState();
    }
    /** 检查输入框 */
    public validateField = (rule: any, value: any, callback: any) => {
        if (rule.required && !value) {
            return callback(rule.message);
        }
        return callback();
    }
    /** 自定义输入框验证 */
    public validatorFiledExtra = (rule: any, value: any, callback: any) => {
        if (rule.required) {
            if (!value && (value !== 0 && value !== '0')) {
                return callback('必填');
            }
        }
        if (value || value === 0 || value === '0') {
            if (rule.pattern != null && !rule.pattern.test(value)) {
                callback(rule.message);
            }
        }
        return callback();
    }
}

export default new ModulesFormAction();



// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/Modules.Form.Action.tsx